import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
    // sessionStorage localStorage
    storage: window.localStorage
})

const state = {
    headerIndwx: 0,
    uCenterIndex: 0,
    stepIndex: 0,
    payStatus: 0,
    nickName: "",
    userInfo: '',
    searchObj: {
        searchName: '',
        searchCC: '',
        searchNum: 2
    },
    searchDate: [],
}
const mutations = {
    saveHeaderIndex: function (state, roslov) {
        state.headerIndwx = roslov;
    },
    saveUserInfo: function (state, info) {
        state.userInfo = info;
    },
    changeUIndex: function (state, uIndex) {
        state.uCenterIndex = uIndex;
    },
    changeSIndex: function (state, sIndex) {
        state.stepIndex = sIndex;
    },
    changePay: function (state, pIndex) {
        state.payStatus = pIndex;
    },
    saveName: function (state, uname) {
        state.nickName = uname;
    },
    saveSearch: function (state, sobj) {
        state.searchObj = sobj;
    },
    saveDate: function (state, sdate) {
        state.searchDate = sdate;
    }
}
const getters = {}
const actions = {}
const store = new Vuex.Store({
    state,
    mutations,
    getters,
    actions,
    plugins: [vuexLocal.plugin]
})
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js